import i18n from "i18next";
import { getWopiAppLabel } from "src/api/generated/documents/wopi/discovery/wopiApp";
import { openWopiFilePage } from "./wopiFilePageUtils";
import { AsyncButtonContextMenuItem } from "src/components/common/contextMenu/AsyncButtonContextMenuItem";
import { AavoContextMenuContext } from "src/components/common/contextMenu/AavoContextMenu";
import { getWopiAppForExtension } from "./wopiAppUtils";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export interface EditDocumentWithWopiButtonMenuItemProps {
	fileExtension: string | undefined,
	fileUuid: string | undefined;
	visible?: boolean
}

export const EditDocumentWithWopiButtonMenuItem = (
	{
		fileExtension,
		fileUuid,
		visible = true
	}: EditDocumentWithWopiButtonMenuItemProps) => {

	const { closeContextMenu } = useContextOrThrow(AavoContextMenuContext);
	if (fileExtension === undefined || fileUuid === undefined || visible === false)
		return null;

	const wopiApp = getWopiAppForExtension(fileExtension);
	if (wopiApp === undefined)
		return null;

	const iconUrl = `/icons/cspp/${wopiApp.toLowerCase()}_16x1.png`;
	const appFriendlyName = getWopiAppLabel(wopiApp);

	return <AsyncButtonContextMenuItem
		iconEl={<img src={iconUrl} alt={"icon"} />}
		onClick={async () => {
			openWopiFilePage("edit", fileUuid);
			closeContextMenu();
		}}
		label={i18n.t("edit_in_microsoft_online", { app: appFriendlyName })}
	/>;
};
